<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    v-html="path"
  ></svg>
</template>

<script>
import { SVG_PATHS } from "@/constants/icons";

export default {
  name: "IconBase",
  props: ["name"],
  computed: {
    path() {
      return SVG_PATHS[this.name] || "";
    },
  },
};
</script>
